;
/*!
 * jquery.vedettesgallery.js
 */

;(function ( $, undefined ) {


	// Create the defaults, only once!
	var defaults = {
		itemsPerColumn: 9
	};

	// The actual plugin constructor
	function VedettesGallery ( galleryContainer ) {
		this.galleryContainer = galleryContainer;
		this.options = $.extend( {}, defaults, this.options );

		this.init();
	}

	VedettesGallery.prototype = {

		init: function () {
			var _this = this;

			_this.$galleryContainer = $( this.galleryContainer );
			//console.log('[VedettesGallery]',_this.$galleryContainer);
			if ( _this.$galleryContainer.length < 1 ) {
				return;
			}

			_this.$body = $( 'body' );
			_this.isModeTfo = PLA.UTILS.modeTfo();


			// destroy potential previous instance
			var $existingModal = $( '.gallery-modal' );
			if ( $existingModal.length > 0 ) {
				$existingModal.remove();
				_this.unbindGalleryEvents();
			}


			_this.compileAllItems();

			if ( _this.galleryItems.length > 0 ) {
				_this.groupGalleryIntoColumns();
				//console.log('[VedettesGallery]',_this.galleryItems);
				_this.bindGalleryEvents();
				_this.setupCarousel();
			}
		},


		compileAllItems: function () {
			var _this = this;


			_this.$galleryItemContainers = _this.$galleryContainer.find( '.gallery-item-container' );
			_this.$galleryItems = _this.$galleryItemContainers.find( '.gallery-item-launcher' );
			_this.$galleryPanel = _this.$galleryContainer.find( '.vedette-gallery-panel' );

			_this.$galleryItems.last().addClass( 'last-launcher' );

			// console.log(
			// 	'_this.$galleryItemContainers', _this.$galleryItemContainers,
			// 	'_this.$galleryItems', _this.$galleryItems
			// );

			_this.galleryItems = [];

			_this.$galleryItems.each( function ( i, el ) {
				var $this = $( this ),
					contentType = $this.data( 'content-type' ),
					fullImage = $this.data( 'image-full' ),
					videoTq = $this.data( 'video-id' ),
					videoTfo = $this.data( 'video-url' ),
					videoTfoCc = $this.data( 'video-cc-url' ),
					videoTfoTranscription = $this.data( 'video-transcription' ),
					title = $this.data( 'video-title' ),
					itemIndex = i;

				_this.galleryItems.push( {
					contentType          : contentType,
					fullImage            : fullImage,
					videoTq              : videoTq,
					videoTfo             : videoTfo,
					videoTfoCc           : videoTfoCc,
					videoTfoTranscription: videoTfoTranscription,
					itemIndex            : itemIndex,
					title                : title
				} );

				$this.data( 'itemIndex', itemIndex );

			} );


			//console.log( 'compiling gallery items', _this.galleryItems );
		},


		groupGalleryIntoColumns: function () {
			var _this = this;


			var iGalleryElementCount = _this.$galleryItems.length;

			for ( var i = 0; i < iGalleryElementCount; i += _this.options.itemsPerColumn ) {
				_this.$galleryItemContainers.slice( i, i + _this.options.itemsPerColumn ).wrapAll( '<div class="gallery-block" />' );
			}

		},

		setupCarousel: function () {
			var _this = this;


			_this.$galleryPanel.slick( {
				slide       : '.gallery-block',
				arrows      : true,
				appendArrows: _this.$galleryContainer.find( '.vedette-gallery-outer-container' ),
				infinite    : false
			} );

			// On before slide change
			_this.$galleryPanel.on( 'afterChange', function ( event, slick, currentSlide, nextSlide ) {
				var $activeSlide = slick.$slides.eq( currentSlide );
				$activeSlide.find( '.gallery-item-launcher' ).eq( 0 ).focus();
			} );
		},

		bindGalleryEvents: function () {
			var _this = this;


			//console.log( '[VedettesGallery] Binding events' );


			_this.$galleryContainer.on( 'click.vedetteItemClick', '.gallery-item-launcher', function ( e ) {
				e.preventDefault();

				var $this = $( this );

				_this.currentIndex = $this.data( 'itemIndex' );
				_this.$currentlyClickedGalleryItem = $this;

				_this.maybeCreateModal();

				_this.displayItem();


				if ( history && history.pushState ) {
					var urlReplace = "#" + $( this ).attr( 'id' ); // make the hash the id of the modal shown
					history.pushState( null, null, urlReplace ); // push state that hash into the url
				}

				// If a pushstate has previously happened and the back button is clicked, hide any modals.
			} );


			_this.$body.on( 'click.vedetteClose', '.gallery-modal', function ( e ) {
				if ( $( e.target ).hasClass( 'gallery-modal' ) || $( e.target ).hasClass( 'gallery-modal-close' ) || $( e.target ).is( 'svg' ) ) {
					_this.closeModal();
				}
			} );


			_this.$body.on( 'click.vedetteTfoPlay', '.gallery-modal .video-tfo .btn-play', function ( e ) {
				var $this = $( this ),
					videoUrl = $this.data( 'video-url' ),
					$parentContainer = $this.parents( '.video-player' );

				if ( videoUrl ) {
					SubitoTexto.videoTfo.replaceWithVideo( $parentContainer, videoUrl );
				}
			} );

			_this.$body.on( 'click.vedetteTfoToggleTranscription', '.video-transcript-toggler', function ( e ) {
				var $this = $( this ),
					isActive = $this.hasClass( 'active' ),
					$siblingTranscription = $this.siblings( '.video-transcription' );

				if ( isActive ) {
					$this.removeClass( 'active' );
					_this.hideTranscript( $siblingTranscription, true );
				} else {
					$this.addClass( 'active' );
					_this.showTranscript( $siblingTranscription );
				}
			} );


			_this.$body.on( 'click.vedetteNextPrevItem', '.gallery-modal .modal-nav-btn', function ( e ) {
				var $this = $( this ),
					isNext = $this.hasClass( 'modal-btn-next' );

				if ( isNext ) {
					// current is the last one
					_this.currentIndex++;
					if ( _this.currentIndex >= _this.galleryItems.length ) {
						_this.currentIndex = 0;
					}

				} else {
					_this.currentIndex--;
					if ( _this.currentIndex < 0 ) {
						_this.currentIndex = _this.galleryItems.length - 1;
					}
				}

				_this.displayItem();
			} );


			_this.$body.on( 'keydown.modalKeyPress', '.gallery-modal', function ( e ) {
				// ESC closes
				var $target = $( e.target );
				//console.log( e, $target );


				if ( e.keyCode === PLA.a11y.keys.esc ) {
					_this.closeModal();
				}

				// Normal tab
				else if ( e.keyCode == PLA.a11y.keys.tab && e.shiftKey == false ) {

					if ( $target.hasClass( 'modal-btn-next' ) || (!$( this ).hasClass( 'multiple-panels' ) && $target.hasClass( 'video-transcript-toggler' )) ) {

						_this.$btnCloseModal.eq( 0 ).focus();
						e.preventDefault();
					} else if (
						($target.hasClass( 'btn-play' ) || $target.hasClass( 'vjs-fullscreen-control' ) )
						&& _this.$modal.find( '.video-transcript-toggler' ).length < 1 && !$( this ).hasClass( 'multiple-panels' )
					) {
						_this.$btnCloseModal.eq( 0 ).focus();
						e.preventDefault();
					}


				} else if ( e.keyCode == PLA.a11y.keys.tab && e.shiftKey == true && $( e.target ).hasClass( 'gallery-modal-close' ) ) {

					var $modalNextArrow = _this.$modal.find( '.modal-btn-next' );

					if ( $modalNextArrow.length > 0 ) {
						$modalNextArrow.focus();
					} else if ( _this.$modal.find( '.video-transcript-toggler' ).length > 0) {
						_this.$modal.find( '.video-transcript-toggler' ).focus();
					} else {
						_this.$modal.find( '.btn-play' ).focus();
					}
					e.preventDefault();
				}
			} );


			if ( history && history.pushState ) {
				$( window ).on( 'popstate', function () {
					_this.closeModal();
				} );
			}

		},


		unbindGalleryEvents: function () {
			var _this = this;

			_this.$galleryContainer.off( 'click.vedetteItemClick' );
			_this.$body.off( 'click.vedetteClose' );
			_this.$body.off( 'click.vedetteTfoPlay' );
			_this.$body.off( 'click.vedetteTfoToggleTranscription' );
			_this.$body.off( 'click.vedetteNextPrevItem' );
			_this.$body.off( 'keydown.modalKeyPress' );

			if ( history && history.pushState ) {
				$( window ).off( 'popstate' );
			}
		},


		maybeCreateModal: function () {
			var _this = this;


			if ( typeof  _this.$modal == 'undefined' ) {
				_this.$modal = $( '<div class="gallery-modal">' + _this.closeSvg + '<div class="safety-max"></div></div>' ).appendTo( 'body' ).hide();
				_this.$modalContent = $( '<div class="gallery-modal-content"></div>' ).appendTo( _this.$modal.find( '.safety-max' ) );
				_this.$modalTitle = $( '<h3 class="modal-title" />' ).prependTo( _this.$modal );

				if ( _this.galleryItems.length > 1 ) {
					_this.$prevBtn = $( '<button type="button" class="modal-nav-btn modal-btn-prev">Élément précédent</button>' ).appendTo( _this.$modal );
					_this.$nextBtn = $( '<button type="button" class="modal-nav-btn modal-btn-next">Élément suivant</button>' ).appendTo( _this.$modal );
					_this.$modal.addClass( 'multiple-panels' );
				} else {
					_this.$modal.removeClass( 'multiple-panels' );
				}

				_this.$btnCloseModal = _this.$modal.find( '.gallery-modal-close' ).eq( 0 );
			}

			if ( typeof _this.isModalOpen == 'undefined' ) {
				_this.isModalOpen = false;
			}

			_this.debounceResize();
		},

		showModal: function () {
			var _this = this;


			if ( !_this.isModalOpen ) {
				_this.$modal.stop().fadeIn( 'fast', function () {
						_this.isModalOpen = true;

						var $playBtn = _this.$modal.find( '.btn-play' );
						if ( $playBtn.length > 0 ) {
							$playBtn.focus();
						}
					}
				);

			}
		},

		closeModal: function () {
			var _this = this;

			if ( typeof _this.$modal != 'undefined' ) {
				_this.$modal.stop().fadeOut( 'fast' );
				_this.$modalContent.html( '' );
			}
			_this.isModalOpen = false;

			if ( typeof _this.$currentlyClickedGalleryItem != 'undefined' && _this.$currentlyClickedGalleryItem.length > 0 ) {
				_this.$currentlyClickedGalleryItem.focus();
			}
		},

		destroyModal: function () {
			var _this = this;

		},


		destroyGallery: function () {
			var _this = this;

		},


		displayItem: function () {
			var _this = this;

			var currentItem = _this.galleryItems[ _this.currentIndex ],
				contentType = currentItem.contentType;

			_this.$modalTitle.show();


			// image
			if ( contentType == "image" ) {

				_this.$modalContent
					.html( '<img class="modal-image" src="' + currentItem.fullImage + '" />' )
					.removeClass( 'mode-video' )
					.addClass( 'mode-image' );
			}

			// Video TQ
			else if ( contentType == "video-tq" ) {


				var videoHtml = '<div class="video video-tq" ';

				var dataVideo = {
					mediaUid: currentItem.videoTq,
					autoPlay: false,
					//	posterFrame :currentItem.fullImage
				};

				// TQ Player needed info
				videoHtml += ' data-video = \'' + JSON.stringify( dataVideo ) + '\' >';

				videoHtml += '</div>';

				_this.$modalContent
					.html( videoHtml )
					.removeClass( 'mode-image' )
					.addClass( 'mode-video' );

				// TQ's player isn't really responsive, so it needs to gather its size info.
				// Let's give the modal time to show up before initiating it.
				setTimeout( function () {
					_this.$modalContent.find( '.video' ).Tq_VideoPlayer();
				}, 500 );

			}


			// Video TFO
			else if ( contentType == "video-tfo" ) {
				var ccProperty = typeof currentItem.videoTfoCc != 'undefined' && currentItem.videoTfoCc.length > 0 ? ' data-video-cc-url="' + currentItem.videoTfoCc + '" ' : '',
					videoHtml = '<div class="video-player video video-tfo content-block"' + ccProperty + '>';

				videoHtml += '<img src="' + currentItem.fullImage + '" alt="' + currentItem.title + '" class="video-thumb">';
				videoHtml += '<button class="btn-play" role="button" data-video-url="' + currentItem.videoTfo + '"' + ccProperty + '>';
				videoHtml += '<span class="screen-reader-only">Cliquer pour démarrer la vidéo</span>';
				videoHtml += '<img class="btn-play-svg" src="/_/images/btn-play.svg" /></button>';
				videoHtml += '</div>';

				_this.$modalContent
					.html( videoHtml )
					.removeClass( 'mode-image' )
					.addClass( 'mode-video' );

				var $safetyMax = _this.$modalContent.parents( '.safety-max' );

				$safetyMax.find( '.video-transcript-toggler' ).remove();
				$safetyMax.find( '.video-transcription' ).remove();

				if ( currentItem.videoTfoTranscription && currentItem.videoTfoTranscription != '' ) {
					$safetyMax
						.addClass( 'video-tfo-template' )
						.append( '<button class="video-transcript-toggler" type="button"><span class="open">Afficher la vidéo transcription</span><span class="close">Cacher la vidéo transcription</span></button>' )

					var $videoTranscription = $( '<div class="video-transcription">' + currentItem.videoTfoTranscription + '</div>' ).appendTo( $safetyMax );
					_this.hideTranscript( $videoTranscription );
				}


			}
			if ( currentItem.title.trim().length > 0 ) {
				_this.$modalTitle.html( currentItem.title.trim() );
			} else {
				_this.$modalTitle.hide();
			}

			_this.makeSureItFits();
			_this.showModal();
		},

		debounceResize: function () {
			var _this = this;

			if ( typeof  _this.debouncedModalFit === 'undefined' ) {

				var debounceFitting = PLA.UTILS.debounce( function () {
					_this.makeSureItFits();
				}, 250 );

				window.addEventListener( 'resize', debounceFitting );
			}
		},

		makeSureItFits: function () {
			var _this = this;

			var $win = $( window ),
				winHeight = $win.height(),
				winWidth = $win.width(),
				isVideoMode = _this.$modalContent.hasClass( 'mode-video' ),
				vidRatio = 16 / 9,
				vidWidthCalRatio = 9 / 16,
				safetyRatio = 0.8,
				maxHeight = winWidth / vidRatio * safetyRatio,
				calcWidth = Math.floor( ( winHeight * safetyRatio) * vidRatio ),
				doesItFit = maxHeight < winHeight;

			if ( isVideoMode ) {
				if ( calcWidth > winWidth ) {
					_this.$modal.find( '.safety-max' ).outerWidth( Math.floor( winWidth * 0.9 ) );
				} else if ( !doesItFit ) {
					_this.$modal.find( '.safety-max' ).outerWidth( calcWidth );
				} else {
					_this.$modal.find( '.safety-max' ).outerWidth( Math.floor( winWidth * safetyRatio ) );
				}


			} else {
				// image mode
				var $image = _this.$modalContent.find( 'img' ),
					clonedImage = new Image();


				//http://stackoverflow.com/a/25843547
				clonedImage.onload = function () {
					var imgRatio = clonedImage.width / clonedImage.height,
						imgWidthCalRatio = clonedImage.height / clonedImage.width,
						safetyRatio = 0.8,
						maxHeight = winWidth / imgRatio * safetyRatio,
						calcWidth = Math.floor( ( winHeight * safetyRatio) * imgRatio ),
						doesItFit = maxHeight < winHeight;

					if ( calcWidth > winWidth ) {
						_this.$modal.find( '.safety-max' ).outerWidth( Math.floor( winWidth * 0.9 ) );
					} else if ( !doesItFit ) {
						_this.$modal.find( '.safety-max' ).outerWidth( calcWidth );
					} else {
						_this.$modal.find( '.safety-max' ).outerWidth( Math.floor( winWidth * safetyRatio ) );
					}
				}

				clonedImage.src = $image.attr( 'src' );


			}

		},

		hideTranscript: function ( $transcriptContainer, shouldScroll ) {
			var _this = this;

			$transcriptContainer.hide().removeClass( 'active' );

			if ( shouldScroll ) {
				$transcriptContainer.parents( '.video-tfo-template' ).animate( {
					scrollTop: 0
				}, 300 );
			}

		},

		showTranscript: function ( $transcriptContainer ) {
			var _this = this;

			$transcriptContainer.show().addClass( 'active' );

			$transcriptContainer.parents( '.video-tfo-template' ).animate( {
				scrollTop: $transcriptContainer.position().top - 200
			}, 300 );

		},

		closeSvg: '<button type="button" class="gallery-modal-close"><span class="screen-reader-only screen-reader-only-focusable">Fermer la fenêtre</span><svg version="1.1" class="video-modal-close-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28.991 29.698" enable-background="new 0 0 28.991 29.698" xml:space="preserve"><g id="XMLID_2_"><line id="XMLID_1_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="0.354" y1="28.638" x2="28.638" y2="0.354"/><line id="XMLID_3_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="28.638" y1="29.345" x2="0.354" y2="1.061"/></g></svg></button>'


	}

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn.vedettesGallery = function ( options ) {
		return this.each( function () {
			if ( !$.data( this, "VedettesGallery" ) ) {
				$.data( this, "VedettesGallery", new VedettesGallery( this, options ) );
			}
		} );
	}


})( jqPla );

